export const LONG_TAP = 300;
